import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        root: {
            minHeight: 300,
            maxHeight: 500,
        },
    }
})

export default useStyles
